import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeAbout = () => {
  const [AboutUser, setAboutUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getAbout");
      setAboutUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteAbout/${userId}`);

      setAboutUser(
        (prevUsers) => prevUsers.filter((user) => user.id !== userId) 
      );

      toast.error("Data Deleted Successfully!");
      navigate("/About");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {/* <Link to="/About-add">
            <button className="Banner-button">Add</button>
          </Link> */}

          {AboutUser.map((user) => {
            
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.title1}{" "}
                  <Link to={`/About-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                  {/* <span onClick={() => deleteUser(user.id)}>
                    {" "}
                    <i
                      title="Delete"
                      className="fa-solid fa-trash-can action-sec"
                      style={{ color: "red" }}
                    ></i>
                  </span> */}
                </h3>
                <p dangerouslySetInnerHTML={{__html: user.description1}}></p>
                {" "}
                        <img
                          src={user.aboutimage}
                          alt="About"
                          style={{ width: "700px", height: "500px" }}
                        />
        
                <hr/>
        <h3>{user.title2}</h3>
                <p dangerouslySetInnerHTML={{ __html: user.description2 }}></p>
                <hr/>
                <h3>{user.title3}</h3>
                <p dangerouslySetInnerHTML={{__html: user.description3}}></p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export const HomeAboutEdit = () => {
  const [Aboutuser, setAboutUser] = useState({
    title1: "",
    description1: "",
    aboutimage: "",
    title2: "",
    description2: "",
    title3: "",
    description3: "",
  });

  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // Load CKEditor script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) => {
          window.CKEDITOR.instances[instance].destroy(true);
        });
      }
    };
  }, []);

  // Fetch existing About data
  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getoneAbout/${id}`
      );
      if (response.data.success) {
        setAboutUser(response.data.data);

        if (window.CKEDITOR.instances.editor1) {
          window.CKEDITOR.instances.editor1.setData(response.data.data.description1);
        }
        if (window.CKEDITOR.instances.editor2) {
          window.CKEDITOR.instances.editor2.setData(response.data.data.description2);
        }
        if (window.CKEDITOR.instances.editor3) {
          window.CKEDITOR.instances.editor3.setData(response.data.data.description3);
        }
      }
    } catch (error) {
      console.error("Error fetching About data!", error);
      toast.error("Failed to load About data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) {
      fetchAboutData();

      if (!window.CKEDITOR.instances.editor1) {
        window.CKEDITOR.replace("editor1");
      }
      if (!window.CKEDITOR.instances.editor2) {
        window.CKEDITOR.replace("editor2");
      }
      if (!window.CKEDITOR.instances.editor3) {
        window.CKEDITOR.replace("editor3");
      }
    }
  }, [editorLoaded, id]);

  useEffect(() => {
    if (Aboutuser.aboutimage && typeof Aboutuser.aboutimage === "string") {
      setPreviewImage(Aboutuser.aboutimage);
    }
  }, [Aboutuser.aboutimage]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setAboutUser({ ...Aboutuser, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB
  
      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }
  
      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }
  
      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  
      img.onload = () => {
        const { width, height } = img;
  
        // Example check (adjust if needed)
        if (width > 1250 || height > 900) {
          toast.error("Image dimensions should not exceed 1250x900.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }
  
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };

  // Submit updated data
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title1", Aboutuser.title1);
    formData.append("description1", window.CKEDITOR.instances.editor1?.getData() || "");
    formData.append("title2", Aboutuser.title2);
    formData.append("description2", window.CKEDITOR.instances.editor2?.getData() || "");
    formData.append("title3", Aboutuser.title3);
    formData.append("description3", window.CKEDITOR.instances.editor3?.getData() || "");

    if (selectedImage) {
      formData.append("aboutimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateAbout/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/About");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error updating the About!", error);
      toast.error("Failed to update About.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/About">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Title 1</label>
                <input
                  type="text"
                  value={Aboutuser.title1}
                  onChange={changeHandler}
                  className="form-control"
                  name="title1"
                  required
                />
                <br/>
              </div>

              <div className="form-group">
                <label>Description 1</label>
                <textarea id="editor1"></textarea>
                <br/>
              </div>

              <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="aboutimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                  />
                )}
              </div>

              <div className="form-group">
                <br/>
                <label>Title 2</label>
                <input
                  type="text"
                  value={Aboutuser.title2}
                  onChange={changeHandler}
                  className="form-control"
                  name="title2"
                  required
                />
                <br/>
              </div>

              <div className="form-group">
                <label>Description 2</label>
                <textarea id="editor2"></textarea>
                <br/>
              </div>

              <div className="form-group">
                <label>Title 3</label>
                <input
                  type="text"
                  value={Aboutuser.title3}
                  onChange={changeHandler}
                  className="form-control"
                  name="title3"
                  required
                />
                <br/>
              </div>

              <div className="form-group">
                <label>Description 3</label>
                <textarea id="editor3"></textarea>
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/About">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};



export const AboutAdd = () => {
  const [AboutData, setAboutData] = useState({
    title1: "",
    description1: "",
    aboutimage: null, 
    title2: "",
    description2: "",
    title3: "",
    description3: "",
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setAboutData((prev) => ({ ...prev, [name]: value }));
  };

  const imageHandler = (e) => {
    const file = e.target.files[0]; // Get selected file
    setAboutData((prev) => ({ ...prev, aboutimage: file }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title1", AboutData.title1);
      formData.append("description1", AboutData.description1);
      formData.append("aboutimage", AboutData.aboutimage);
      formData.append("title2", AboutData.title2);
      formData.append("description2", AboutData.description2);
      formData.append("title3", AboutData.title3);
      formData.append("description3", AboutData.description3);

      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createAbout", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Data added successfully!");
      navigate("/About"); // Redirect after success
    } catch (error) {
      console.error("Error adding About:", error);
      toast.error("Failed to add About!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12"/>
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/About"><i className="fa-solid fa-xmark"></i></Link>
            <h3>Add About Data</h3>
            <form className="row" onSubmit={submitForm} encType="multipart/form-data">
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title1">Title 1</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={AboutData.title1}
                  id="title1"
                  name="title1"
                  placeholder="Enter Title 1"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description1">Description 1</label>
                <textarea
                  onChange={inputHandler}
                  value={AboutData.description1}
                  id="description1"
                  name="description1"
                  placeholder="Enter Description 1"
                  rows="4"
                ></textarea>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="aboutimage">Upload About Image</label>
                <input
                  type="file"
                  id="aboutimage"
                  name="aboutimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title2">Title 2</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={AboutData.title2}
                  id="title2"
                  name="title2"
                  placeholder="Enter Title 2"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description2">Description 2</label>
                <textarea
                  onChange={inputHandler}
                  value={AboutData.description2}
                  id="description2"
                  name="description2"
                  placeholder="Enter Description 2"
                  rows="4"
                ></textarea>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title3">Title 3</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={AboutData.title3}
                  id="title3"
                  name="title3"
                  placeholder="Enter Title 3"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description3">Description 3</label>
                <textarea
                  onChange={inputHandler}
                  value={AboutData.description3}
                  id="description3"
                  name="description3"
                  placeholder="Enter Description 3"
                  rows="4"
                ></textarea>
              </div>
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

